import { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import PickupLocation from '@/components/location/PickupLocation';
import Breadcrumb from "@/components/breadcrumb";

export function VirtualTour({ tourUrl, storeId, showBreadcrumbs }) {
  const [iframeInteractionAllowed, setIframeInteractionAllowed] = useState(false);
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleOverlayClick = () => setIframeInteractionAllowed(true);

  const handleDocumentClick = (event) => {
    if (
      !event.target.closest('iframe') &&
      !event.target.closest(`.${styles.overlay}`)
    ) {
      setIframeInteractionAllowed(false);
    }
  };

  useEffect(() => {
    const fetchStore = async () => {
      setLoading(true);
      try {
        const res = await fetch(`/api/jane-store/${storeId}`);
        if (!res.ok) throw new Error(`Failed to fetch store: ${res.status}`);
        const data = await res.json();
        setStore(data.data.store);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchStore();
    document.body.addEventListener('click', handleDocumentClick);
    return () => document.body.removeEventListener('click', handleDocumentClick);
  }, [storeId]);

  // if (loading) return <p>Loading data...</p>;
  if (error) return <p>Error: {error.message}</p>;


  return (
    <div className={styles.virtualTour}>
        {/* <Breadcrumb /> */}
      <div className={styles.contentWrapper}>
        {store && (
          <div className={styles.location}>
            <PickupLocation key={store.id} store={store} showVirtualButton={false} />
          </div>
        )}
        {tourUrl && (
          <div className={styles.iframeContainer}>
            {!iframeInteractionAllowed && (
              <div className={styles.overlay} onClick={handleOverlayClick}>
                Click to start tour
              </div>
            )}
            <iframe
              className={`${styles.iframe} ${
                iframeInteractionAllowed ? styles.interactable : ''
              }`}
              width="100%"
              allowFullScreen
              src={tourUrl}
            ></iframe>
          </div>
        )}
      </div>
    </div>
  );
}
